// package
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
// custom
import { usePageLayout } from '@/app/router';
import { ROUTES } from '@/app/router/routes';
import CloseButton from '@shared/components/CloseButton';
import Image301 from '@shared/assets/dna/image_301_x2.jpg';
import { useLanguage } from '@shared/contexts/LanguageContext';

export const DnaCloseButton = ({ ...props }) => {
  return (
    <CloseButton style={{ position: 'absolute', top: 20, right: 20 }} {...props} />
  );
}

export const DnaNextButton = ({ ...props }) => {
  return (
    <button
      type="button"
      className="mb-10 ml-auto mr-3 mt-auto flex h-20 w-20 items-center justify-center rounded-full border-0 p-0"
      style={{
        background: 'linear-gradient(180deg, #4DC8E0 0%, #0097B2 100%)',
        boxShadow: '1px 1px 10px rgba(0, 0, 0, 0.50)',
        visibility: props.visibility ? 'hidden' : 'visible',
      }}
      {...props}
    >
      <ChevronRight size={80} color="#FFFFFF" strokeWidth={2.5} aria-hidden />
    </button>
  );
}

//---------------------------------------------------------------------------
const DnaListPage = () => {
  const navigate = useNavigate();
  const { setLayoutOptions } = usePageLayout();
  const { t, currentLanguage } = useLanguage();
  const isEn = currentLanguage.code === 'en';
  const arrRuleText = [t('dna.rule1'), t('dna.rule2')];

  useEffect(() => {
    setLayoutOptions({ hideHeader: true, hideBottomNav: true, hideFooter: true });
    return () => setLayoutOptions({});
  }, [setLayoutOptions]);

  //---------------------------------------------------------------------------
  const onClickBack = () => {
    navigate(-1);
  };

  const handleStart = () => {
    navigate(ROUTES.DNA_QUESTION);
  };

  //---------------------------------------------------------------------------
  return (
    <section
      className="relative mx-auto min-h-[932px] w-full max-w-[430px] overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #ECFCFF 0%, #F7F8FA 100%)' }}
    >
      <img src={Image301} alt=""  data-layer="image 301" className="absolute inset-0 h-full w-full object-cover" />

      <div className="relative z-10 flex min-h-[932px] flex-col px-6 py-8">
        <DnaCloseButton onClick={onClickBack} />

        <div data-layer="三十五年來" className={`mt-[400px] px-8 font-normal text-[#6E625B] ${isEn ? 'text-[16px] leading-[26px]' : 'text-[20px] leading-[32px]'}`}>
          {arrRuleText.map((text, i) => (
            <span key={i} className={i === 0 ? '' : 'mt-4'}>
              {text}
              <br />
            </span>
          ))}
        </div>

        <DnaNextButton onClick={handleStart} data-layer={`"Rectangle 4407" "Vector 439"`}  />
      </div>
    </section>
  );
};

export default DnaListPage;